import{RECEIVE_SEARCH_RESULTS}from"../constants";/**
 * Creates the dispatched RECEIVE_SEARCH_RESULTS action object.
 * @param {string} searchPhrase The search phrase.
 * @param {number} offset The result offset.
 * @param {Object} results The search results.
 * @return {Object} The RECEIVE_SEARCH_RESULTS action.
 */var receiveSearchResults=function receiveSearchResults(searchPhrase,offset,results){return{type:RECEIVE_SEARCH_RESULTS,searchPhrase:searchPhrase,offset:offset,results:results};};export default receiveSearchResults;